import React, { FC, useCallback } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Grid } from '@mui/material'
import { IntroducerStatusEnum } from '@sparling/financial-common'
import { useDispatch } from 'react-redux'
import { InputField } from '../../../components/InputField'
import { Modal } from '../../../components/Modal'
import { IData } from '../UserProfileTabs'
import { introducerApprovalResolver } from './resolvers'
import { introducerDataUpdateRequest } from '../../../store/actions'

interface IntroducerApproveModalProps
  extends Pick<IData, 'idSf' | 'introducerCommission' | 'introducerBankFee' | 'introducerLiquidityFee'> {
  isOpen: boolean
  modalClose: () => void
  refresh?: () => void
}

export const IntroducerApproveModal: FC<IntroducerApproveModalProps> = ({
  isOpen,
  modalClose,
  idSf,
  introducerCommission,
  introducerBankFee,
  introducerLiquidityFee,
  refresh,
}) => {
  const dispatch = useDispatch()
  const formMethods = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    shouldFocusError: true,
    resolver: introducerApprovalResolver,
  })
  const {
    handleSubmit,
    formState: { isValid },
  } = formMethods

  const onSubmit = useCallback(
    (data) => {
      if (idSf)
        dispatch(
          introducerDataUpdateRequest({
            idSf,
            ...data,
            introducerStatus: IntroducerStatusEnum.APPROVED,
          }),
        )
      modalClose()
      if (refresh) refresh()
    },
    [refresh, idSf, modalClose, dispatch],
  )

  return (
    <Modal
      title="Introducer Approval"
      submitTitle="Approve"
      isOpen={isOpen}
      modalClose={modalClose}
      onSubmit={handleSubmit(onSubmit)}
      isSubmitDisabled={!isValid}
    >
      <FormProvider {...formMethods}>
        <Grid container direction="column">
          <Grid item xs={12}>
            <InputField
              labelName={'Commission'}
              inputName="introducerCommission"
              inputType="text"
              defaultValue={introducerCommission}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputField
              labelName={'Bank Fee'}
              inputName="introducerBankFee"
              inputType="text"
              defaultValue={introducerBankFee}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputField
              labelName={'Liquidity Fee'}
              inputName="introducerLiquidityFee"
              inputType="text"
              defaultValue={introducerLiquidityFee}
              fullWidth
            />
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  )
}
